<section class="section_one">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="state__sec">
                    <ul class="state__list">
                        <li *ngFor="let data of total | filter:searchkey:'cityName'">
                      
                            <div class="statelist__flex">
                                <div class="statetitle__flex">
                                    <div>
                                        <h5 class="state__name">{{data.cityName}}
                                        </h5>
                                        
                                    </div>
                                    <div>
                                        <h6 class="state__dvr">Id: <span
                                                class="dvr__color">{{data.cityId}}</span></h6>
                                    </div>
                                </div>
                                <div class="cctv__colflex">
                                    <div class="cctv__camflex">
                                        <div>
                                            <figure class="mb-0">
                                                <img src="../../assets/image/cctv.jpg" class="cctv" alt="cctv">
                                            </figure>
                                        </div>
                                        <div>
                                            <h6 class="cctv__title" (click)="onButtonClick(data)">CCTV Installed</h6>
                                            <h5 class="cctv__number">{{data.totalCamerasInstalled}}</h5>
                                        </div>
                                    </div>
                                    <div>
                                        <h6 class="cctv__title" (click)="onButtonClick(data)">Connected</h6>
                                        <h5 class="cctv__number">{{data.totalConnected}}</h5>
                                    </div>
                                    <div>
                                        <h6 class="cctv__title" (click)="onButtonClick(data)">Not Connected</h6>
                                        <h5 class="cctv__number">{{data.totalNotConnected}}</h5>
                                    </div>
                                    <div>
                                        <h6 class="cctv__title" (click)="onButtonClick(data)">Streaming</h6>
                                        <h5 class="cctv__number">{{data.totalVideoStreaming}}</h5>
                                    </div>
                                    <div>
                                        <h6 class="cctv__title" (click)="onButtonClick(data)">No Video</h6>
                                        <h5 class="cctv__number">{{data.totalVideoNotStreaming}}</h5>
                                    </div>
                                    <div (click)="onButtonClick(data)">
                                        <figure class="mb-0">
                                            <img 
                                                src="../../assets/image/rightarrow.png" class="rightarrow"
                                                alt="rightarrow">
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>
<!--=================== loader ===================-->
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>